import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { Device } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DevicesResolverActions = createActionGroup({
  source: 'Devices resolver',
  events: {
    'Device requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DevicesApiActions = createActionGroup({
  source: 'Devices API',
  events: {
    'Devices loaded': props<{ devices: Device[] }>(),
    'Devices loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceSignalRHubActions = createActionGroup({
  source: 'Device SignalR Hub',
  events: {
    'Device changed': props<{ device: Device }>(),
    'Device removed': props<{ device: Device }>(),
  },
});
